import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import posthog from 'posthog-js';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-interview-survey',
  standalone: true,
  imports: [CommonModule, FormsModule, NzIconModule, NzButtonModule, NzModalModule, NzRateModule, NzSegmentedModule],
  templateUrl: './interview-survey.component.html',
  styleUrl: './interview-survey.component.scss',
})
export class InterviewSurveyComponent {
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  rateList = Array.from({ length: 11 }, (_, i) => i);
  rate: number | undefined = undefined;

  onOnInit() {
    posthog.capture('survey shown', {
      $survey_id: environment.posthogSurvey.interviewEndSurvey,
    });
  }

  handleIndexChange(index: number) {
    this.rate = index;
  }

  handleOk() {
    posthog.capture('survey sent', {
      $survey_id: environment.posthogSurvey.interviewEndSurvey,
      $survey_response: `${this.rate}`,
    });

    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }
}
